import { Routes, Route } from "react-router-dom";

import Home from "./Home";
import ProjectArchive from "./ProjectArchive";
import FourOFour from "./FourOFour";
import ShadowDial from "./ShadowDial";
import PrivacyPolicy from "./ShadowDial/PrivacyPolicy";
import TermsOfUsage from "./ShadowDial/TermsOfUsage";
import Piggy from "./Piggy";
import PiggyPrivacy from "./Piggy/Privacy";
import PiggyTerms from "./Piggy/Terms";
import Wedding from "./Wedding/Design3";
import { setColorScheme, getColorScheme } from "../utils";

const App = () => {
  setColorScheme(getColorScheme("dark"));

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/project-archive" element={<ProjectArchive />} />
      <Route path="/shadow-dial" element={<ShadowDial />} />
      <Route path="/shadow-dial/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/shadow-dial/terms-of-usage" element={<TermsOfUsage />} />
      <Route path="/piggy" element={<Piggy />} />
      <Route path="/piggy/privacy" element={<PiggyPrivacy />} />
      <Route path="/piggy/terms" element={<PiggyTerms />} />
      <Route path="/wedding" element={<Wedding />} />
      <Route path="/*" element={<FourOFour />} />
    </Routes>
  );
};

export default App;
